export default __webpack_public_path__ + "static/origami-60b94d6f95f829a904da6ca37f22c924.jpg";